<template>
  <div class="w-100 list-group mb-3  bg-white">
    <div class="py-3 mx-2 d-flex align-content-center justify-content-between border-bottom">
      <div class="fw-bold w-auto my-0 lh-base h5" >注册参赛 </div>
      <div class="text-secondary  w-auto my-0 lh-base " >微纳大赛 / 注册参赛 </div>
    </div>
<!--    <hr class=" my-1 mx-3"/>-->
    <!--    表单-->
    <div class="w-100 p-3" >
      <p class="lh-lg pub-text-indent">“明石杯”中国大学生微纳大赛已入选《全国普通高校学科竞赛排行榜》，是教育部认可的 57 项全国性大学生竞赛项目之一，该大赛包括机械创意、机械创新和机械毕业设计三个赛道共13个赛项。微纳传感技术与智能应用赛是中国大学生机械工程创新创意大赛机械创新赛道的第七个赛项，是入选《全国普通高校学科竞赛排行榜》的赛项之一，由中国机械工程学会主办、明石创新（烟台）微纳传感技术研究院冠名支持。“微纳传感赛”旨在通过竞赛创新活动充分激发大学生对微纳传感技术的兴趣，启迪创新思想，加快传感技术创新步伐，促进传感技术的产业化应用，同时为传感器产业培育一批应用型、复合型专业人才，是我国微纳传感领域创新型人才培养的重要组成部分。</p>
      <p class="lh-lg pub-text-indent">“明石杯”中国大学生微纳大赛将从微纳传感器的实际应用角度出发，以微纳传感器的创新研究及其智能应用为依托展开。按照未来微纳传感器及其智能应用对大学生技能的要求设置比赛项目，比赛内容覆盖了微纳传感器的创新设计、微纳工艺研究、极端条件的标定测试及其智能应用等方面，不仅能考察参赛选手的创新能力和专业实践能力，更能培养其解决复杂工程问题的本领。主要面向智能制造与装备、航空航天、海工装备、微电子与通讯工程、过程装备与流程控制、生物医药、可穿戴电子产品、物联网领域等实际应用背景。</p>
      <p class="lh-lg pub-text-indent">参赛对象为在读的全日制专科生、本科生和研究生，以参赛队伍为单位进行报名，每支参赛队伍由2-5名学生组成，每位学生只能参加一支参赛队伍，指定队长1名。每支赛队可指定1-2名指导教师，每位指导教师最多同时指导2支参赛队伍。参赛学生专业不限，鼓励跨学科组队。</p>
      <p class="lh-lg pub-text-indent">初赛设置一等奖和二等奖，颁发获奖证书（电子版）；决赛设置一等奖、二等奖、三等奖等，颁发获奖证书并发放奖金。</p>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped lang="scss">

</style>
